// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function GooglePlayLogoIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M27.977 14.274 7 2.27a2 2 0 0 0-2.74.724 1.96 1.96 0 0 0-.26.99v24.032a1.96 1.96 0 0 0 .99 1.709 2 2 0 0 0 2.015 0l20.973-12a1.968 1.968 0 0 0 0-3.453v.002ZM6 26.584V5.416L16.586 16 6 26.584Zm12-9.17 2.365 2.365L9.302 26.11 18 17.414ZM9.3 5.887l11.066 6.334L18 14.586 9.3 5.888ZM22.164 18.75 19.414 16l2.75-2.75L26.967 16l-4.803 2.75Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
